<template>
  <button type="submit" class="send__reset__button" @click.native="trackEvent">
    <slot />
  </button>
</template>
<script>
export default {
  name: "Button",
  props: ["analytics"],
  methods: {
    trackEvent: function () {
      this.$ga.event(this.analytics);
    },
  },
};
</script>
<style lang="scss" scoped>
.send__reset__button {
  background: #0A50E6;
  color: #73c9ff;
  height: 45px;
  border: none;
  padding: 0 10px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background: #73c9ff;
    color: #0A50E6;
  }
}
</style>
